<qr-icon v-if="name" class="h-6 w-6 fill-current" :name="name"></qr-icon>
